const MAX_CITATOR_CASES_RETURNED = 1000

export type CaseCountBadgeProps = {
  count: number
}

export function CaseCountBadge({ count }: CaseCountBadgeProps) {
  const label = count >= MAX_CITATOR_CASES_RETURNED ? `${MAX_CITATOR_CASES_RETURNED}+` : String(count)

  return (
    <span className="inline-flex items-center justify-center min-w-[18px] h-[22px] px-1.5 py-0.5 text-sm font-semibold leading-5 text-true-gray-700 bg-brand-neutral-200 rounded-full">
      {label}
    </span>
  )
}
